/**
 * AuthProvider — wraps the app and supplies AuthContext.
 * Renders a full-page spinner while the initial /api/me is in flight.
 */

import React from 'react'
import {
  AuthContext,
  useMeQuery,
  useLoginMutation,
  useLogoutMutation,
} from '@/hooks/useAuth'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const meQuery = useMeQuery()
  const loginMutation = useLoginMutation()
  const logoutMutation = useLogoutMutation()

  const login = async (email: string, password: string) => {
    await loginMutation.mutateAsync({ email, password })
  }

  const logout = async () => {
    await logoutMutation.mutateAsync()
  }

  // Still waiting for the initial /api/me response
  if (meQuery.isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
      </div>
    )
  }

  return (
    <AuthContext.Provider
      value={{
        user: meQuery.data ?? null,
        isLoading: meQuery.isLoading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
